/**
 * Slovak translations — source of truth for all UI strings.
 * English copy must match the same structure exactly (see ./en.ts).
 */
export const sk = {
  common: {
    save: "Uložiť",
    saveChanges: "Uložiť zmeny",
    cancel: "Zrušiť",
    delete: "Zmazať",
    close: "Zatvoriť",
    open: "Otvoriť",
    yes: "Áno",
    no: "Nie",
    confirm: "Potvrdiť",
    loading: "Načítavam…",
    saving: "Ukladám…",
    saved: "Uložené",
    edit: "Upraviť",
    add: "Pridať",
    create: "Vytvoriť",
    search: "Hľadať",
    comingSoon: "Čoskoro",
    error: "Nastala chyba",
    guest: "Hosť",
    you: "ty",
    back: "Späť",
    next: "Ďalej",
    done: "Hotovo",
    skip: "Preskočiť",
    apply: "Použiť",
    remove: "Odstrániť",
    rename: "Premenovať",
    duplicate: "Duplikovať",
    archive: "Archivovať",
    restore: "Obnoviť",
    today: "Dnes",
    yesterday: "Včera",
    tomorrow: "Zajtra",
    none: "Žiadny",
    all: "Všetko",
    unassigned: "Bez priradenia",
    noResults: "Žiadne výsledky",
    optional: "voliteľné",
    required: "povinné",
    name: "Meno",
    description: "Popis",
    color: "Farba",
    or: "alebo",
    and: "a",
    showMore: "Zobraziť viac",
    showLess: "Zobraziť menej",
  },
  imageViewer: {
    view: "Zobraziť obrázok",
    download: "Stiahnuť",
    fullscreen: "Na celú obrazovku",
    exitFullscreen: "Ukončiť celú obrazovku",
  },

  sidebar: {
    expand: "Rozbaliť menu",
    collapse: "Zbaliť menu",
    collapseAll: "Zbaliť všetky boardy",
    expandAll: "Rozbaliť všetky boardy",
    pin: "Pripnúť menu",
    unpin: "Odopnúť menu",
    closeMenu: "Zavrieť menu",
    openMenu: "Otvoriť menu",
    system: "Systém",
    groups: {
      work: "Práca",
      sales: "Obchod",
      clientsGroup: "Klienti",
      finance: "Financie",
      people: "Tím",
      docs: "Dokumenty",
      infra: "Infraštruktúra",
    },
    items: {
      dashboard: "Dashboard",
      projects: "Projekty",
      tasks: "Moje úlohy",
      calendar: "Kalendár",
      clients: "Klienti",
      contracts: "Zmluvy",
      billing: "Faktúry",
      pricing: "Cenník",
      cashflow: "Cashflow",
      reports: "Reporty",
      team: "Používatelia",
      timeoff: "Dovolenky",
      files: "Súbory",
      wiki: "Wiki",
      approvals: "Schvaľovania",
      domains: "Domény",
      servers: "Servery",
      notifications: "Notifikácie",
      trash: "Kôš",
      settings: "Nastavenia",
    },
  },

  topbar: {
    titles: {
      "/": "Dashboard",
      "/tasks": "Úlohy",
      "/projects": "Projekty",
      "/clients": "Klienti",
      "/calendar": "Kalendár",
      "/billing": "Faktúry",
      "/pricing": "Cenník",
      "/cashflow": "Cashflow",
      "/reports": "Reporty",
      "/team": "Používatelia",
      "/timeoff": "Dovolenky",
      "/files": "Súbory",
      "/wiki": "Wiki",
      "/approvals": "Schvaľovania",
      "/domains": "Domény",
      "/servers": "Servery",
      "/notifications": "Notifikácie",
      "/kos": "Kôš",
      "/settings": "Nastavenia",
    },
    searchPlaceholder: "Hľadať…",
    liveDot: "online",
  },

  vox: {
    label: "VOX - hlasový asistent",
    requesting: "Pripájam mikrofón…",
    listening: "Počúvam…",
    deniedTitle: "Mikrofón nedostupný",
    denied: "Prístup k mikrofónu je zablokovaný. Povoľ ho v nastaveniach prehliadača a skús znova.",
    hint: "Povedz úlohu - napr. „Vytvor úlohu … v projekte … pre …“.",
    done: "Hotovo",
    phaseNote: "VOX prepíše reč a vytvorí úlohu priamo v MACAY.",
    transcribing: "Prepisujem reč…",
    understanding: "Rozumiem príkazu…",
    transcriptEmpty: "Nezachytili sme žiadnu reč - skús to znova.",
    createdTitle: "Úloha vytvorená",
    navigateTitle: "Otváram zobrazenie",
    notCreatedTitle: "Nič som nevytvoril",
    errorTitle: "Nastala chyba",
    unrecognized: "Nerozpoznal som príkaz. Skús to povedať inak.",
    errorTranscribe: "Prepis zlyhal. Skús to znova.",
    errorCommand: "Príkaz sa nepodarilo spracovať.",
    fieldTitle: "Úloha",
    fieldProject: "Projekt",
    fieldAssignee: "Priradené",
    fieldPriority: "Priorita",
    fieldDeadline: "Termín",
    unassigned: "nikto",
    prioLow: "nízka",
    prioMedium: "stredná",
    prioHigh: "vysoká",
    openTask: "Otvoriť úlohu",
    goTo: "Zobraziť",
    retry: "Povedať znova",
    transcriptTitle: "Prepis",
    transcriptUnsupported: "Tento prehliadač nepodporuje rozpoznávanie reči.",
    transcriptNext: "Ďalšie možnosti prídu čoskoro.",
  },

  comingSoon: {
    badge: "Čoskoro",
    devStub: {
      title: "DEV STUB",
      body: "Táto stránka je placeholder pre vývoj — slúži na overenie navigácie, modulových farieb a layout-u. Reálna implementácia príde neskôr.",
    },
  },

  modules: {
    calendar: {
      title: "Kalendár",
      group: "Práca",
      description: "Termíny, meetingy a deadliny v jednom časovom plátne. Synchronizácia s Google Calendar a Outlook.",
    },
    contracts: {
      title: "Zmluvy",
      group: "Klienti",
      description: "Zmluvy a dokumenty per klient - verzie, platnosť, podpisy a expirácie na jednom mieste.",
    },
    billing: {
      title: "Faktúry",
      group: "Financie",
      description: "Vystavovanie, evidencia úhrad, automatické pripomienky nezaplatených faktúr a export do účtovníctva.",
    },
    pricing: {
      title: "Cenník",
      group: "Obchod",
      description: "Štruktúrovaný katalóg služieb a produktov s cenami per klient. Automatické naplnenie do faktúr.",
    },
    cashflow: {
      title: "Cashflow",
      group: "Financie",
      description: "Live view kam tečú peniaze — príjmy, výdavky, mesačná bilancia, kategórie a 3-mesačná prognóza.",
    },
    reports: {
      title: "Reporty",
      group: "Financie",
      description: "Týždenné reporty pre klientov — ľudským jazykom zhrnú, čo sa urobilo a bude fakturované, so schválením admina a view-only odkazom pre klienta.",
    },
    team: {
      title: "Používatelia",
      group: "Tím",
      description: "Org chart, hierarchia podriadených, mzdové podklady, pozývanie nových členov tímu cez email.",
    },
    timeoff: {
      title: "Dovolenky",
      group: "Tím",
      description: "Žiadosti o PTO, kalendár absencií tímu, multi-stage schvaľovací proces, evidencia zostatku dovoleniek.",
    },
    files: {
      title: "Súbory",
      group: "Dokumenty",
      upload: "Nahrať",
      dropHint: "Presuň súbory sem alebo klikni",
      empty: "Zatiaľ žiadne súbory",
      download: "Stiahnuť",
      browserTitle: "Súbory projektu",
      search: "Hľadať súbor…",
      sortNew: "Najnovšie",
      sortName: "Názov",
      sortSize: "Veľkosť",
      typeAll: "Všetky",
      typeImage: "Obrázky",
      typeDoc: "Dokumenty",
      typeOther: "Ostatné",
      allTasks: "Všetky úlohy",
      noMatch: "Nič nezodpovedá filtru",
      description: "Centrálny file hub naprieč projektmi, verzionovanie, fulltext search, per-projekt prístupy.",
    },
    wiki: {
      title: "Wiki",
      group: "Dokumenty",
      description: "Znalostná báza firmy — onboarding docs, SOP-y, „ako u nás robíme veci”. Replacement pre Notion/Confluence.",
    },
    approvals: {
      title: "Schvaľovania",
      group: "Dokumenty",
      description: "Multi-stage approval workflow pre zmluvy, nákupy, výdavky — s digitálnym podpisom a auditom.",
    },
    domains: {
      title: "Domény",
      group: "Infraštruktúra",
      description: "Evidencia firemných domén — expirácie, DNS záznamy, registrátor info, automatické pripomienky obnovy.",
    },
    servers: {
      title: "Servery",
      group: "Infraštruktúra",
      description: "Monitoring serverov — uptime, certifikáty, naviazanie na klienta/projekt. Real-time alerts pri výpadkoch.",
    },
  },

  settings: {
    title: "Nastavenia",
    sections: {
      profile: "Profil",
      security: "Bezpečnosť",
      quickAction: "Rýchla akcia",
      appearance: "Vzhľad",
      tutorial: "Tutoriál",
      notifications: "Notifikácie",
      team: "Používatelia",
      integrations: "Integrácie",
      account: "Účet",
    },
    sectionDescriptions: {
      profile: "Tvoje meno, kontakt a rola v tíme.",
      security: "Zmena hesla. Pre potvrdenie musíš zadať aktuálne heslo.",
      quickAction: "Kam ťa vezme tlačidlo „Rýchla akcia“ na dashboarde.",
      appearance: "Téma a predvolené správanie bočného panelu.",
      tutorial: "Rýchla prehliadka základov MACAY-u.",
      notifications: "Email digest, frekvencia, typy udalostí.",
      team: "Správa členov tímu, pozývanie a role.",
      integrations: "Prepojenia s ďalšími službami a nástrojmi.",
      account: "Export tvojich dát, deaktivácia účtu, fakturácia.",
    },
    quickAction: {
      hint: "Vyber cieľ, na ktorý ťa tlačidlo „Rýchla akcia“ na dashboarde prenesie.",
      choose: "Vybrať rýchlu akciu",
      notSet: "Zatiaľ nenastavená",
      change: "Zmeniť",
      remove: "Odstrániť",
      saved: "Rýchla akcia uložená",
      removed: "Rýchla akcia odstránená",
    },
    profile: {
      avatar: "Tvoj avatar",
      avatarHint: "PNG, JPG, WEBP alebo GIF, do 5 MB.",
      avatarUpload: "Nahrať fotku",
      avatarChange: "Zmeniť fotku",
      avatarRemove: "Odstrániť",
      cropTitle: "Orež fotku",
      cropConfirm: "Orezať a nahrať",
      cropBusy: "Nahrávam...",
      name: "Meno a priezvisko",
      email: "Email",
      role: "Rola",
      roleAdminNote: "(mení iba admin)",
      roles: { admin: "Admin", member: "Člen tímu", client: "Klient" },
    },
    security: {
      currentPassword: "Súčasné heslo",
      newPassword: "Nové heslo",
      newPasswordAgain: "Nové heslo (znova)",
      minChars: "Minimálne 6 znakov.",
      mismatch: "Heslá sa nezhodujú",
      changePassword: "Zmeniť heslo",
      changed: "Heslo zmenené",
      showPassword: "Zobraziť heslo",
      hidePassword: "Skryť heslo",
    },
    appearance: {
      theme: "Téma",
      themeHint: "Tvoje nastavenie sa pamätá medzi zariadeniami.",
      light: "Svetlá",
      lightSub: "Klasický denný režim",
      dark: "Tmavá",
      darkSub: "Šetrné pre oči, ideálne večer",
      active: "AKTÍVNA",
      sidebar: "Sidebar (bočný panel)",
      sidebarHint: "Predvolený stav po otvorení aplikácie.",
      expanded: "Rozbalený",
      expandedSub: "S nadpismi modulov",
      collapsed: "Zbalený",
      collapsedSub: "Iba ikony, viac priestoru",
      language: "Jazyk",
      languageHint: "Jazyk používateľského rozhrania.",
      languageSubSk: "Slovenský jazyk",
      languageSubEn: "English language",
    },
    tutorial: {
      completed: "Tutoriál si už dokončil",
      completedSubBefore: "Dokončené",
      completedSubAfter: ". Kedykoľvek si ho môžeš znova prejsť — žiadne dáta sa nezmenia.",
      notCompleted: "Tutoriál ešte nebol dokončený",
      notCompletedSub: "Spusti si rýchlu prehliadku 6 krokov, ktorá ťa prevedie základmi MACAY-u.",
      start: "Spustiť tutoriál",
    },
    comingSections: {
      notifications: {
        b1: "Týždenný digest tvojich projektov",
        b2: "Okamžité emaily pri priradení úlohy",
        b3: "Push notifikácie do mobilu",
        b4: "Tichý režim počas víkendu",
      },
      team: {
        b1: "Pozvať nového člena cez email",
        b2: "Zmeniť rolu (admin / člen / klient)",
        b3: "Deaktivovať účet bez mazania jeho histórie",
        b4: "Audit log akcií",
      },
      integrations: {
        b1: "Slack — notifikácie do tímového kanálu",
        b2: "Google Kalendár — synchronizácia termínov",
        b3: "Gmail — komentáre cez odpoveď na email",
        b4: "Webhooks — vlastné napojenia",
      },
      account: {
        b1: "Export všetkých tvojich dát (JSON / CSV)",
        b2: "Deaktivácia účtu (dáta ostanú, ale prihlasovanie sa zruší)",
        b3: "Definitívne zmazanie účtu",
        b4: "Faktúry a história platieb (keď bude verejný plán)",
      },
    },
  },

  login: {
    title: "Prihlásenie",
    subtitle: "Prihlás sa do svojho MACAY účtu",
    email: "Email",
    emailPlaceholder: "tvoj@email.sk",
    password: "Heslo",
    passwordPlaceholder: "tvoje heslo",
    signIn: "Prihlásiť sa",
    signingIn: "Prihlasovanie…",
    wrongCredentials: "Nesprávny email alebo heslo",
    showPassword: "Zobraziť heslo",
    hidePassword: "Skryť heslo",
    fillField: "Vyplň toto pole",
    backToSite: "Späť na web",
    forgotLink: "Zabudnuté heslo?",
    stageEyebrow: "Jeden systém namiesto dvanástich",
    stageTitleA: "Práca, ktorá",
    stageTitleEm: "plynie",
    stageTitleB: "sama.",
    stagePoint1: "Projekty, klienti, fakturácia aj dokumenty - jedno prihlásenie.",
    stagePoint2: "Žiadne kopírovanie dát medzi dvanástimi nástrojmi.",
    stagePoint3: "Systém prispôsobený vašej firme, nie naopak.",
    stageNote: "Interný systém pre celý tím.",
  },
  auth: {
    forgotTitle: "Obnovenie hesla",
    forgotSubtitle: "Zadaj svoj email a pošleme ti odkaz na nastavenie nového hesla.",
    emailLabel: "Email",
    emailPlaceholder: "tvoj@email.sk",
    forgotSubmit: "Poslať odkaz",
    forgotSending: "Posielam…",
    forgotSent: "Ak účet s týmto emailom existuje, poslali sme naň odkaz na obnovenie hesla. Skontroluj si schránku (aj spam).",
    backToLogin: "Späť na prihlásenie",
    resetTitle: "Nové heslo",
    resetSubtitle: "Zvoľ si nové heslo k svojmu účtu.",
    newPassword: "Nové heslo",
    confirmPassword: "Zopakuj heslo",
    resetSubmit: "Nastaviť heslo",
    resetting: "Ukladám…",
    resetSuccess: "Heslo bolo zmenené. Teraz sa môžeš prihlásiť.",
    goToLogin: "Prihlásiť sa",
    resetInvalid: "Tento odkaz je neplatný alebo už expiroval. Požiadaj o nový.",
    passwordsMismatch: "Heslá sa nezhodujú",
    passwordTooShort: "Heslo musí mať aspoň 8 znakov",
    requestNew: "Požiadať o nový odkaz",
    showPassword: "Zobraziť heslo",
    hidePassword: "Skryť heslo",
  },


  viewAs: {
    banner: "Pozeráš sa ako klient:",
    stop: "Skončiť pohľad",
    chooseClient: "Vyber klienta",
    viewAs: "Pozri ako klient",
    activeAs: "Aktívny pohľad ako:",
    buttonLabel: "Pozrieť ako iný účet",
    headerLabel: "Pozerať ako",
    sectionTeam: "Používatelia",
    sectionClients: "Klienti",
    subtext: "Po výbere sa appka začne tváriť ako keby si bol prihlásený za daný účet. Späť cez fialový banner hore.",
    bannerViewing: "Pozeráš ako",
    bannerBackAs: "Späť ako",
    noClients: "Žiadni klienti.",
  },

  userMenu: {
    settings: "Nastavenia",
    logout: "Odhlásiť",
    profile: "Profil",
  },

  notifications: {
    title: "Notifikácie",
    empty: "Zatiaľ žiadne notifikácie",
    emptySub: "Tu uvidíš, keď ťa niekto priradí, okomentuje alebo nahrá súbor.",
    markAllRead: "Označiť všetko ako prečítané",
    seeAll: "Zobraziť všetky",
    enablePush: "Povoliť upozornenia v prehliadači",
    pushEnabled: "Upozornenia v prehliadači zapnuté",
    pushDenied: "Prehliadač upozornenia zablokoval",
    popupCloseAria: "Zavrieť upozornenie",
    emptyCategory: "Žiadne notifikácie v tejto kategórii",
    unreadOnly: "Len neprečítané",
    pageSubtitle: "Kompletná história tvojich notifikácií.",
    groups: {
      today: "Dnes",
      yesterday: "Včera",
      earlier: "Skôr",
    },
    categories: {
      all: "Všetky",
      tasks: "Úlohy",
      projects: "Projekty",
      clients: "Klienti",
      reports: "Reporty",
      account: "Účet",
    },
    types: {
      assigned: "ťa priradil k úlohe",
      commented: "okomentoval úlohu",
      projectAdded: "ťa pridal do projektu",
      taskUpdated: "upravil úlohu",
      projectUpdated: "upravil projekt",
      clientDeleteRequest: "žiada o zmazanie klienta",
      clientDeleteApproved: "schválil zmazanie klienta",
      clientDeleteRejected: "zamietol zmazanie klienta",
      uploaded: "nahral súbor",
      deadlineSoon: "deadline sa blíži",
      mention: "ťa spomenul v komentári",
      roleChanged: "zmenil tvoje oprávnenia",
      accountDeactivated: "deaktivoval tvoj účet",
      reportInputNeeded: "potrebuje tvoju časť reportu",
      reportReadyForReview: "report je pripravený na kontrolu",
      reportUpdated: "upravil report",
    },
    time: {
      justNow: "pred chvíľou",
      minutesAgo: "pred {n} min",
      hoursAgo: "pred {n} h",
      daysAgo: "pred {n} d",
    },
  },

  dashboard: {
    welcome: "Vitaj späť",
    helloPrefix: "Ahoj,",
    myTasks: "Moje úlohy",
    myTasksAll: "Všetky moje úlohy",
    noTasksTitle: "Žiadne úlohy",
    noTasksSub: "Keď ti niekto priradí úlohu, zobrazí sa tu.",
    overdue: "Po termíne",
    overduePlural: "po termíne",
    dueToday: "Dnes",
    dueThisWeek: "Tento týždeň",
    dueLater: "Neskôr",
    noDeadline: "Bez termínu",
    assignedTo: "Priradené tebe",
    forUser: "Pre {name}",
    tasksCount: "{n} priradených",
    daysOverdue: "dní po termíne",
    todayShort: "dnes",
    tomorrowShort: "zajtra",
    inDays: "za {n} dní",
    priorityLabel: "Priorita",
    overdueShort: "po termíne",
    openAll: "Otvoriť všetky",
    noAssignedTasks: "Žiadne priradené úlohy.",
    quickAdd: "Rýchla akcia",
    todaysTasks: "Úlohy na dnes",
    clientOfMonth: "Klient mesiaca",
    activeClient: "Aktívny klient",
    open: "Otvoriť",
    tasksWord: "Úlohy",
    doneShort: "hotových",
    dbErrorTitle: "Načítanie zlyhalo",
    sectionTasksHint: "Stav projektov v jednom prehľade",
    sectionDomainsHint: "Najbližšie expirácie",
    sectionNotifsHintAfter: "neprečítaných",
    sectionClientsHint: "Aktívni klienti",
    expiresInDays: "{n} dní",
    needsAttention: "vyžaduje pozornosť",
    attentionItem: "vec",
    attentionFew: "veci",
    attentionMany: "vecí",
    taskOne: "úloha",
    taskFew: "úlohy",
    taskMany: "úloh",
    domainOne: "doména",
    domainFew: "domény",
    domainMany: "domén",
    beforeExpiry: "pred koncom platnosti",
    allUnderControl: "Všetko pod kontrolou",
    noUrgentTail: " — nič urgentné dnes na teba nečaká.",
    statsActive: "Aktívne",
    statsProjects: "Projekty",
    statsServers: "Servery",
    statsClients: "Klienti",
    statsClientsSub: "aktívni v MACAY",
    statsActiveTasks: "Aktívne úlohy",
    statsActiveTasksSub: "hotových tento týždeň",
    statsDomains: "Domény",
    statsDomainsSub: "expirujú do 30 dní",
    statsNotifs: "Notifikácie",
    statsNotifsSub: "neprečítaných celkom",
  },

  shortcuts: {
    title: "Skratky",
    add: "Pridať",
    edit: "Upraviť",
    done: "Hotovo",
    added: "Skratka pridaná",
    renamePrompt: "Premenovať skratku:",
    emptyCta: "Pridať skratku",
    emptyHint: "Pripni si úlohu, board, klienta alebo modul pre rýchly prístup.",
    pickerTitle: "Pripnúť skratku",
    searchPlaceholder: "Hľadaj úlohu, board, klienta, projekt alebo modul…",
    searchHint: "Píš aspoň 2 znaky pre vyhľadanie úloh.",
    groupModules: "Moduly",
    groupViews: "Pohľady",
    groupBoards: "Boardy",
    groupTasks: "Úlohy",
    groupClients: "Klienti",
    groupProjects: "Projekty",
    noResults: "Nič sa nenašlo.",
    viewMine: "Moje úlohy",
    viewDelegated: "Delegované úlohy",
    viewAll: "Všetky úlohy",
    viewByClient: "Úlohy podľa klienta",
    viewByProject: "Úlohy podľa projektu",
    pinView: "Pripnúť pohľad",
    pinViewPrompt: "Názov pripnutého pohľadu:",
  },

  tasks: {
    titlePlural: "Úlohy",
    newTask: "Nová úloha",
    newGroup: "Nový board",
    newBoard: "Nový board",
    addTask: "Pridať úlohu",
    addGroup: "Pridať board",
    addBoard: "Pridať board",
    taskName: "Názov úlohy",
    taskNamePlaceholder: "Čo treba urobiť?",
    groupNameRequired: "Názov boardu je povinný",
    groupCreatePlaceholder: "napr. Čaká na klienta",
    neutralGroupHint: "Vlastné boardy sú „neutrálne” — pri presune úlohy do nich sa stav úlohy nezmení. Stav sa mení iba pri presune do To Do, Vo vývoji, alebo Hotovo.",
    groupName: "Názov boardu",
    groupNamePlaceholder: "Napr. To do, Rozrobené, Hotové",
    boardNameRequired: "Názov boardu je povinný",
    boardCreatePlaceholder: "napr. Marketing kampaň",
    autoGroupsHint: "Automaticky pridáme tri boardy:",
    boardName: "Názov boardu",
    boardNamePlaceholder: "Napr. Úlohy webu",
    renameBoard: "Premenovať board",
    boardOptions: "Možnosti boardu",
    boardDescription: "Popis boardu",
    addBoardDescription: "Pridať popis",
    editBoardDescription: "Upraviť popis",
    boardDescriptionPlaceholder: "Na čo je tento board? (voliteľné)",
    groupOptions: "Možnosti boardu",
    boardStatsGroups: "boardov",
    boardStatsTasks: "úloh",
    taskOne: "úloha",
    taskFew: "úlohy",
    taskMany: "úloh",
    renameGroup: "Premenovať board",
    sortByStatusItem: "Zoradiť podľa stavu",
    hideDoneItem: "Skryť hotové",
    showDoneItem: "Zobraziť hotové",
    hideBoardItem: "Schovať board",
    hiddenBoardsLabel: "Skryté boardy",
    restoreAllBoards: "Zobraziť všetky",
    convertToProject: "Konvertovať na projekt",
    convert: {
      title: "Konvertovať board na projekt",
      subtitle: "Z boardu „{name}“ sa stane samostatný projekt.",
      projectName: "Názov projektu",
      pickTitle: "Ktoré tasky sa stanú boardmi",
      pickHint: "Zaškrtnuté tasky sa v novom projekte stanú samostatnými boardmi (stĺpcami). Ich podúlohy sa presunú pod ne ako karty.",
      assignTitle: "Kam presunúť zvyšné tasky",
      assignHint: "Každý zvyšný task sa presunie pod zvolený nový board.",
      targetBoard: "Cieľový board",
      subtasks: "{n} podúloh",
      selectedCount: "{n} boardov",
      allSelected: "Všetky tasky sa stanú boardmi — netreba nič priraďovať.",
      needOne: "Vyber aspoň jeden task, ktorý sa stane boardom.",
      noTasks: "Tento board nemá tasky na konverziu.",
      back: "Späť",
      next: "Ďalej",
      submit: "Konvertovať",
      converting: "Konvertujem…",
      done: "Board skonvertovaný na projekt",
    },
    deleteGroup: "Vymazať board",
    deleteGroupWithTasks: "Vymazať board + úlohy",
    deleteBoard: "Vymazať board",
    deleteBoardWithTasks: "Vymazať board + úlohy",
    deleteBoardConfirm: "Naozaj zmazať tento board so všetkými úlohami?",
    layoutBoard: "Board",
    layoutList: "Zoznam",
    selectBoard: "Vyber board",
    emptyBoardTitle: "Tento board je prázdny",
    emptyBoardSub: "Pridaj prvý board a v ňom prvú úlohu.",
    emptyGroupHint: "Pridať prvú úlohu",
    status: "Stav",
    priority: "Priorita",
    deadline: "Deadline",
    assignees: "Riešitelia",
    description: "Popis",
    comments: "Komentáre",
    links: "Linky",
    files: "Súbory",
    history: "História",
    activity: "Aktivita",
    addComment: "Pridať komentár",
    commentPlaceholder: "Napíš komentár… (Enter pre odoslanie)",
    send: "Odoslať",
    sending: "Posiela sa…",
    deleteTask: "Zmazať úlohu",
    deleteTaskConfirm: "Naozaj zmazať túto úlohu?",
    confirmDelete: "Áno, zmazať",
    descriptionPlaceholder: "Popis úlohy…",
    addLink: "Pridať link",
    linkUrl: "URL",
    linkLabel: "Popisok",
    linkPlaceholderUrl: "https://…",
    linkPlaceholderLabel: "Krátky popis odkazu",
    uploadFile: "Nahrať súbor",
    uploadDrop: "Pretiahni súbory sem alebo klikni",
    uploadHint: "Max 30 MB",
    removeFile: "Odstrániť súbor",
    removeLink: "Odstrániť link",
    noDeadline: "Bez termínu",
    setDeadline: "Nastaviť termín",
    clearDeadline: "Zrušiť termín",
    overdueLabel: "Po termíne",
    statuses: {
      todo: "To do",
      working: "Robí sa",
      stuck: "Zaseknuté",
      done: "Hotovo",
    },
    personStatuses: {
      planned: "Naplánované",
      in_progress: "Prebieha",
      done: "Hotovo",
      paused: "Pozastavené",
    },
    priorities: {
      low: "Nízka",
      medium: "Stredná",
      high: "Vysoká",
      critical: "Kritická",
    },
    person: "Osoba",
    assignedTo: "Zadané komu",
    onePerson: "1 osoba",
    fewPeople: "osoby",
    manyPeople: "osôb",
    allMasc: "Všetci",
    allFem: "Všetky",
    allPlural: "Všetky",
    filters: {
      title: "Filtre",
      all: "Všetko",
      mine: "Moje",
      assignee: "Riešiteľ",
      status: "Stav",
      priority: "Priorita",
      board: "Board",
      project: "Projekt",
      clear: "Zrušiť filtre",
      apply: "Použiť",
    },
    columnMenu: {
      addTask: "Pridať úlohu",
      rename: "Premenovať board",
      delete: "Vymazať board",
      deleteConfirm: "Vymazať board + úlohy",
      color: "Farba",
    },
    eyebrowMine: "Moje úlohy",
    eyebrowDelegated: "Delegované",
    eyebrowAll: "Všetky úlohy",
    heroDelegated: "Delegované úlohy",
    heroAll: "Všetky úlohy",
    heroForUser: "Pre {name}",
    heroSubMine: "{n} priradených mne · {m} celkovo",
    heroSubDelegated: "{n} {w}, ktoré si zadal iným",
    heroSubAll: "{n} {w} naprieč všetkými boardmi",
    filteredSuffix: " · filtrované {n}",
    groupByDeadline: "Zoradené podľa termínu",
    groupByClient: "Zoradené podľa klienta",
    groupByProject: "Zoradené podľa projektu",
    scopeMine: "Moje",
    scopeDelegated: "Delegované",
    scopeAll: "Všetky",
    groupDeadlineShort: "Termín",
    groupClientShort: "Klient",
    groupProjectShort: "Projekt",
    viewList: "Zoznam",
    viewGrid: "Mriežka",
    emptyMine: "Žiadne úlohy ti nie sú priradené",
    emptyDelegated: "Zatiaľ si nikomu nezadal žiadnu úlohu",
    emptyAll: "Žiadne úlohy",
    emptyMineSub1: "Pozri sa do ",
    emptyMineSubAll: "všetkých úloh",
    emptyMineSubOr: " alebo do ",
    emptyMineSubProjects: "projektov",
    emptyDelegatedSub1: "Úlohy, ktoré vytvoríš a priradíš niekomu inému, sa zobrazia tu. Pozri si ",
    emptyDelegatedSubAll: "všetky úlohy",
    emptyAllSub: "Vytvor nový board a pridaj prvú úlohu.",
    noMatchTitle: "Žiadne úlohy nezodpovedajú filtrom",
    noMatchSub1: "Skús ",
    clearFiltersAction: "vyčistiť filtre",
    bucketOverdue: "Po termíne",
    bucketToday: "Dnes",
    bucketWeek: "Tento týždeň",
    bucketLater: "Neskôr",
    bucketNone: "Bez termínu",
    noClientPlaceholder: "Bez klienta",
    daysOverdueChip: "d po termíne",
    todayChip: "dnes",
    tomorrowChip: "zajtra",
    inDaysChip: "o {n} d",
    crumbClients: "Klienti",
    crumbProjects: "Projekty",
    toggleBoards: "Boardy",
    toggleList: "Zoznam",
    boardsHeading: "Boardy",
    crumbInternal: "Interné",
    boardFallback: "Board",
    tasksFallback: "Úlohy",
    statusInProgress: "Prebieha",
    menuEdit: "Upraviť",
    menuRename: "Premenovať",
    menuDelete: "Vymazať",
    reallyDelete: "Naozaj vymazať?",
    taskOptions: "Možnosti úlohy",
    searchPlaceholder: "Hľadať úlohu…",
    filterMineTitle: "Zobraziť len úlohy priradené mne",
    allPeople: "Všetci ľudia",
    anyPriority: "Každá priorita",
    anyDeadline: "Každý termín",
    filterOverdue: "Po termíne",
    filterNext7Days: "Do 7 dní",
    filterNoDeadline: "Bez termínu",
    cancelFiltersCount: "Zrušiť ({n})",
    addAction: "Pridať",
    cancelAction: "Zrušiť",
    noTaskMatchesFilter: "Žiadna úloha nevyhovuje",
    dropTaskHere: "Presuň sem úlohu",
    noGroupsTitle: "Zatiaľ žiadne boardy",
    noGroupsHint: "Vytvor prvý board (napr. To Do, Rozrobené, Hotové) a začni pridávať úlohy.",
    noTasks: "Žiadne úlohy",
    fieldType: "Typ",
    typeTask: "Úloha",
    typeBug: "Chyba",
    typeFeature: "Feature",
    typeMilestone: "Míľnik",
    subtasksLabel: "Subtasky",
    subtaskAddPlaceholder: "Nový subtask...",
    subtaskAddBtn: "Pridať",
    subtaskToggleAria: "Prepnúť stav subtasku",
    subtaskDeleteAria: "Zmazať subtask",
    statusChangeAria: "Zmeniť status",
    noTasksBoardSub: "V tomto boarde zatiaľ nie sú žiadne úlohy.",
    noTasksFilterSub: "Skús upraviť alebo zrušiť filtre.",
    clearDeadlineAria: "Vyčistiť termín",
    assigneesLabel: "Priradení",
    doneLateBy: "dokončené o {n} d po termíne",
    removeFromTask: "Odobrať z úlohy",
    personStatusLabel: "Stav riešiteľov",
    colTask: "Úloha",
    colPerson: "Osoby",
    colStatus: "Stav",
    colDeadline: "Termín",
    colLinks: "Odkazy",
    colFiles: "Súbory",
    colType: "Typ",
    colPriority: "Priorita",
    colComments: "Komentáre",
    noMembers: "Žiadni členovia",
    noLinks: "Žiadne odkazy.",
    openLinkAria: "Otvoriť odkaz",
    linkDescription: "Popis (voliteľné)",
    addLinkBtn: "Pridať odkaz",
    filesLabel: "Súbory",
    dropFilesHere: "Presuňte súbory sem alebo",
    browse: "prehľadávať",
    maxFileSize: "max 25 MB na súbor",
    filesTooLarge: "Niektoré súbory sú príliš veľké a neboli nahraté",
    openFileAria: "Otvoriť súbor",
    removeFileAria: "Odstrániť súbor",
    reorderColumnAria: "Presunúť board",
    uploading: "Nahráva sa…",
    noFiles: "Žiadne súbory.",
    noActivity: "Zatiaľ žiadna aktivita.",
    commentInputPlaceholder: "Napíš komentár…",
    commentSendAria: "Pridať komentár",
    replyAction: "Odpovedať",
    replyPlaceholder: "Napíš odpoveď…",
    markDone: "Označiť ako hotové",
    markedDone: "Hotové",
    editAction: "Upraviť",
    taskNameInputPlaceholder: "Názov úlohy…",
    taskWhatToDoPlaceholder: "Čo treba spraviť?",
    noMembersInTeam: "Žiadni členovia tímu.",
    taskDetailsPlaceholder: "Detaily úlohy…",
    taskAddedTick: "Úloha pridaná ✓ — pokračuj ďalšou",
    createTaskBtn: "Vytvoriť úlohu",
    closeAria: "Zavrieť",
    nameLabel: "Názov",
    deadlineLabel: "Termín",
    addTaskBtn: "Pridať úlohu",
    groupOptionsAria: "Možnosti boardu",
    addToGroup: "Pridať úlohu",
    fileTooLarge: "Súbor je príliš veľký",
    pasteShortcut: "Ctrl+V vloží obrázok zo schránky",
    priorityLabelHigh: "Vysoká",
    priorityLabelMedium: "Stredná",
    priorityLabelLow: "Nízka",
    fieldGroup: "Board",
    fieldPriority: "Priorita",
    fieldDescription: "Popis",
    descPlaceholder: "Bez popisu…",
    linksLabel: "Odkazy",
    activityLabel: "Aktivita",
    commentsLabel: "Komentáre",
    noComments: "Zatiaľ žiadne komentáre",
    nowLabel: "teraz",
    meFallback: "Ja",
    onlyMine: "Len moje",
    filterPerson: "Osoba",
    historyEvents: {
      created: "vytvoril úlohu",
      renamed: "premenoval úlohu",
      statusChanged: "zmenil stav",
      priorityChanged: "zmenil prioritu",
      deadlineSet: "nastavil termín",
      deadlineCleared: "zrušil termín",
      assigneeAdded: "pridal riešiteľa",
      assigneeRemoved: "odobral riešiteľa",
      commented: "okomentoval",
      linkAdded: "pridal link",
      linkRemoved: "odobral link",
      fileUploaded: "nahral súbor",
      fileRemoved: "odstránil súbor",
      moved: "presunul úlohu",
    },
  },

  projects: {
    title: "Projekty",
    internalProjectLabel: "Interný projekt",
    boardsAndTasks: "{b} nástenky · {t} úlohy",
    membersLabel: "Tím projektu",
    noProjectMembers: "Nikto nepriradený",
    editMembers: "Upraviť tím",
    membersSaved: "Tím projektu uložený",
    statusPlanned: "Plánovaný",
    projectOptions: "Možnosti projektu",
    renameProjectAction: "Premenovať projekt",
    deleteProjectAction: "Zmazať projekt",
    renameProjectModal: "Premenovať projekt",
    deleteProjectQ: "Zmazať projekt?",
    deleteWarning1: "Projekt ",
    deleteWarning2: " sa presunie do koša vrátane všetkých boardov a úloh. ",
    deleteWarning3: "Z koša ho vieš obnoviť",
    deleteWarning4: ".",
    toggleBoards: "Boardy",
    toggleList: "Zoznam",
    boardsHeading: "Boardy",
    allTasksLabel: "Všetky úlohy",
    groupsAndTasks: "{g} {gw} · {t} {tw}",
    groupOne: "board",
    groupFew: "boardy",
    groupMany: "boardov",
    taskCountOne: "úloha",
    taskCountFew: "úlohy",
    taskCountMany: "úloh",
    openBoard: "Otvoriť board",
    openAction: "Otvoriť",
    boardOptions: "Možnosti boardu",
    renameBoard: "Premenovať board",
    deleteBoard: "Zmazať board",
    deleteBoardQ: "Zmazať board?",
    deleteBoardWarning1: "Board ",
    deleteBoardWarning2: " sa presunie do koša vrátane boardov a úloh.",
    addBoard: "Pridať board",
    noBoards: "Žiadne boardy",
    noBoardsSub: "Tento projekt zatiaľ nemá žiadny board.",
    noTasks: "Žiadne úlohy",
    noTasksSubProject: "V tomto projekte zatiaľ nie sú žiadne úlohy.",
    newProject: "Nový projekt",
    addProject: "Pridať projekt",
    nameRequired: "Názov je povinný",
    nameLabel: "Názov",
    namePlaceholder: "Napr. Redizajn webu",
    internalNoClient: "Interné / bez klienta",
    status: "Stav",
    statusActive: "Aktívny",
    statusPotential: "Potenciálny",
    statusArchived: "Archivovaný",
    countTotal: "projektov",
    countActive: "aktívnych",
    countPotential: "potenciálnych",
    countArchived: "archivovaných",
    allMasc: "Všetky",
    activeF: "Aktívne",
    potentialF: "Potenciálne",
    archivedF: "Archivované",
    groupNone: "Žiadne",
    groupByClient: "Podľa klienta",
    viewGrid: "Mriežka",
    viewList: "Zoznam",
    allClients: "Všetci klienti",
    clearFilters: "Vyčistiť filtre",
    noForFilter: "Žiadne projekty pre tento filter",
    noForFilterSub: "Skús zmeniť stav alebo klienta, alebo vytvor nový projekt.",
    internal: "Interné",
    boardsPlural: "boardov",
    boardCountOne: "board",
    boardCountFew: "boardy",
    boardCountMany: "boardov",
    openTasksPlural: "otvorených",
    openOne: "otvorená",
    openFew: "otvorené",
    openMany: "otvorených",
    openProject: "Otvoriť projekt",
    projectName: "Názov projektu",
    projectNamePlaceholder: "Napr. Pekáreň Slnečnica — web",
    client: "Klient",
    selectClient: "Vyber klienta",
    noClient: "Bez klienta (interný)",
    deadline: "Deadline",
    description: "Popis projektu",
    descriptionPlaceholder: "O čom je tento projekt?",
    deleteProject: "Zmazať projekt",
    deleteConfirm: "Naozaj zmazať tento projekt?",
    rename: "Premenovať projekt",
    archive: "Archivovať projekt",
    restore: "Obnoviť projekt",
    emptyTitle: "Žiadne projekty",
    emptySub: "Vytvor prvý projekt a začni v ňom evidovať úlohy.",
    tasksCount: "úloh",
    boardsCount: "boardov",
    projectFor: "Projekt pre",
    internalProject: "Interný projekt",
    projectStatusHeading: "Stav projektu",
    projectActions: "Možnosti projektu",
  },

  clients: {
    title: "Klienti",
    newClient: "Nový klient",
    addClient: "Pridať klienta",
    clientNameRequired: "Názov klienta je povinný",
    clientNameModalPlaceholder: "Napr. Pekáreň Pekárová",
    emailPlaceholderShort: "info@firma.sk",
    phoneLabel: "Telefón",
    phonePlaceholderShort: "+421 900 000 000",
    statusLabel: "Stav",
    statusActive: "Aktívny",
    statusLead: "Lead",
    statusPlanned: "Plánovaný",
    phoneShort: "Telefón",
    countTotal: "klientov",
    clientCountOne: "klient",
    clientCountFew: "klienti",
    clientCountMany: "klientov",
    projectsPlural: "projektov",
    projectCountOne: "projekt",
    projectCountFew: "projekty",
    projectCountMany: "projektov",
    openTasksPlural: "otvorených",
    openOne: "otvorená",
    openFew: "otvorené",
    openMany: "otvorených",
    openClient: "Otvoriť klienta",
    clientName: "Názov klienta",
    clientNamePlaceholder: "Napr. Pekáreň Slnečnica",
    clientEmail: "Email klienta",
    clientEmailPlaceholder: "kontakt@firma.sk",
    clientPhone: "Telefón",
    phonePlaceholder: "+421 …",
    color: "Farba klienta",
    deleteClient: "Zmazať klienta",
    deleteConfirm: "Naozaj zmazať tohto klienta?",
    rename: "Premenovať klienta",
    emptyTitle: "Žiadni klienti",
    emptySub: "Pridaj prvého klienta a začni preňho viesť projekty.",
    projectsCount: "projektov",
    activeProjects: "Aktívne projekty",
    clientAccounts: "Klientske účty",
    inviteUser: "Pozvať používateľa",
    clientLabel: "Klient",
    projectsHeading: "Projekty",
    noProjectsTitle: "Klient zatiaľ nemá projekty",
    noProjectsSub: "Pridaj prvý projekt a v ňom boardy úloh.",
    addProjectBtn: "Pridať projekt",
    openProject: "Otvoriť projekt",
    projectStatsBoards: "boardov",
    projectStatsTasks: "úloh",
    statusArchived: "Archivovaný",
    statusInternal: "Interné",
    internalCard: "Interné",
    internalSub: "Projekty bez klienta",
    sortTitle: "Triedenie",
    sortManual: "Vlastné poradie",
    showArchived: "Zobraziť archivované",
    hideArchived: "Skryť archivované",
    archivedF: "Archivované",
    sortName: "Podľa názvu",
    sortStatus: "Podľa stavu",
    sortProjects: "Podľa projektov",
    sortTasks: "Podľa otvorených úloh",
    viewCards: "Karty",
    viewList: "Zoznam",
    manageTitle: "Spravovať klienta",
    editClient: "Upraviť klienta",
    savedToast: "Zmeny uložené",
    logoLabel: "Logo",
    logoUpload: "Nahrať logo",
    logoReplace: "Zmeniť logo",
    logoRemove: "Odstrániť",
    logoHint: "PNG, JPG alebo SVG. Zmenší sa automaticky a uloží sa ku klientovi.",
    logoTypeError: "Vyber prosím obrázok",
    archiveClient: "Archivovať klienta",
    archiveConfirm: "Potvrdiť archiváciu",
    unarchiveClient: "Obnoviť z archívu",
    archivedNote: "Archivovaný klient zostáva so všetkými dátami, len je odložený bokom a v zozname radený na koniec.",
    deleteCascadeNote: "Zmazanie presunie klienta aj všetky jeho projekty, boardy a úlohy do koša. Z koša sa dá všetko obnoviť.",
    deleteConfirmStep: "Potvrdiť zmazanie",
    archivedToast: "Klient archivovaný",
    unarchivedToast: "Klient obnovený z archívu",
    deletedToast: "Klient presunutý do koša",
    deleteRowTitle: "Zmazať klienta",
    archiveRowTitle: "Archivovať klienta",
    restoreRowTitle: "Obnoviť klienta",
    deleteRequested: "Žiadosť o zmazanie odoslaná superadminovi na schválenie",
    pendingTitle: "Žiadosti o zmazanie čakajúce na schválenie",
    pendingRequestedBy: "žiada o zmazanie klienta",
    pendingApprove: "Schváliť a zmazať",
    pendingReject: "Zamietnuť",
    pendingApprovedToast: "Zmazanie schválené, klient v koši",
    pendingRejectedToast: "Žiadosť zamietnutá",
    portalAccess: "Prístup na klientsky portál",
  },

  trash: {
    title: "Kôš",
    empty: "Kôš je prázdny",
    emptySub: "Vymazané položky tu počkajú 30 dní, kým ich definitívne odstránime.",
    restore: "Obnoviť",
    permanentDelete: "Definitívne zmazať",
    deleteConfirm: "Naozaj definitívne zmazať túto položku?",
    deletedOn: "Vymazané",
    daysLeft: "{n} dní do trvalého zmazania",
    types: {
      task: "Úloha",
      group: "Board",
      board: "Board",
      project: "Projekt",
      client: "Klient",
    },
    itemsInTrash: "v koši · obnov alebo zmaž natrvalo",
    itemOne: "položka",
    itemFew: "položky",
    itemMany: "položiek",
    errorPrefix: "Chyba:",
    minutesAgo: "pred {n} min",
    hoursAgo: "pred {n} h",
    daysAgo: "pred {n} d",
    momentAgo: "pred chvíľou",
    cannotRestoreType: "Tento typ sa zatiaľ nedá obnoviť",
    restoreFailed: "Nepodarilo sa obnoviť",
    purgeFailed: "Nepodarilo sa zmazať",
    cannotRestoreTooltip: "Tento typ zatiaľ nepodporuje obnovenie",
    confirmAgain: "Klikni znova pre potvrdenie",
    forever: "Natrvalo",
    reallyQ: "Naozaj?",
    restoreOf: "Obnoviť {name}",
    deleteForeverOf: "Zmazať {name} natrvalo",
    emptyDeep: "Čokoľvek zmažeš (úlohu, board, projekt) tu pristane a vieš to obnoviť alebo dorobiť natrvalo.",
  },

  modal: {
    close: "Zatvoriť",
  },

  tutorial: {
    stop: "Vypnúť tutoriál",
    closeTutorial: "Zavrieť tutoriál",
    next: "Ďalej",
    back: "Späť",
    done: "Hotovo",
    skip: "Preskočiť tutoriál",
    stepOf: "Krok {current} z {total}",
    team: {
      intro: {
        title: "Modul Tím",
        body: "Všetky účty na jednom mieste - admini, členovia a klientske prístupy. Tu sa riadi, kto sa do MACAY dostane a čo môže.",
      },
      stats: {
        title: "Zloženie tímu",
        body: "Rýchly prehľad - koľko je adminov, členov a klientskych účtov, plus pozvánky, ktoré ešte čakajú na prijatie.",
      },
      list: {
        title: "Zoznam členov",
        body: "Pri každom vidíš rolu, priradeného klienta, počet otvorených úloh a odkedy je v tíme. Deaktivované účty sú stlmené.",
      },
      invite: {
        title: "Pridanie člena",
        body: "Nový účet vytvoríš dvomi spôsobmi - pozvánkovým linkom (platí 7 dní, heslo si nastaví sám) alebo priamo s heslom, ktoré mu pošleš.",
      },
      edit: {
        title: "Správa účtu",
        body: "Ceruzkou zmeníš rolu, priradíš klienta alebo účet deaktivuješ. Deaktivovaný sa nevie prihlásiť, jeho história ostáva.",
      },
      done: {
        title: "Tím je pod kontrolou",
        body: "To je celý modul. Tutoriál k ďalším modulom spustíš rovnakým tlačidlom - vždy sa prispôsobí stránke, na ktorej si.",
      },
    },
    projects: {
      intro: {
        title: "Modul Projekty",
        body: "Každý projekt spája všetko k jednej zákazke - boardy úloh, klienta, stav a dokumenty. Odtiaľto sa otvára detail projektu.",
      },
      create: {
        title: "Nový projekt",
        body: "Tu založíš projekt - názov, priradený klient a stav. Board úloh k nemu vznikne automaticky.",
      },
      filter: {
        title: "Filter stavu",
        body: "Prepínaš medzi všetkými, aktívnymi, potenciálnymi a archivovanými projektmi. Vpravo zmeníš mriežku na zoznam.",
      },
      clients: {
        title: "Filter podľa klienta",
        body: "Chipy zúžia zoznam na projekty jedného klienta. Prvý chip vráti všetkých.",
      },
      list: {
        title: "Zoznam projektov",
        body: "Karta ukazuje klienta, stav a počet úloh. Klik otvorí detail projektu s boardmi, úlohami a aktivitou.",
      },
      done: {
        title: "Projekty zvládnuté",
        body: "To je celý modul. Tutoriál funguje na každej stránke - spusti ho kdekoľvek a prevedie ťa práve tým modulom.",
      },
    },
    tasks: {
      intro: {
        title: "Modul Úlohy",
        body: "Kanban board pre každý projekt - úlohy v boardoch, ktoré presúvaš drag & drop. Toto je denný pracovný priestor tímu.",
      },
      header: {
        title: "Hlavička boardu",
        body: "Vidíš aktuálny board, počet boardov a úloh. Chipmi vedľa prepínaš medzi projektmi.",
      },
      create: {
        title: "Nová úloha",
        body: "Pridá úlohu do boardu - názov, board, priradení ľudia, deadline a priorita.",
      },
      board: {
        title: "Boardy",
        body: "Boardy sú stĺpce projektu. Úlohy medzi nimi presúvaš myšou, klik na kartu otvorí detail s komentármi a kompletnou históriou zmien.",
      },
      done: {
        title: "Úlohy zvládnuté",
        body: "To je jadro MACAY - väčšina práce tímu žije práve tu. Tutoriál spustíš rovnako v každom module.",
      },
    },
    clients: {
      intro: {
        title: "Modul Klienti",
        body: "Evidencia klientov - kontakty, stav spolupráce a projekty pokope. Klient môže dostať aj vlastný prístup.",
      },
      create: {
        title: "Nový klient",
        body: "Založíš klienta s kontaktnými údajmi a stavom (aktívny, potenciálny, archív).",
      },
      list: {
        title: "Karty klientov",
        body: "Karta ukazuje kontakt, stav a projekty klienta. Klik otvorí detail so všetkým, čo sa klienta týka.",
      },
      accounts: {
        title: "Klientsky prístup",
        body: "Klientovi vieš vytvoriť login v module Tím (rola Klient) - cez vlastné prihlásenie vidí len svoje projekty a môže komentovať, bez prístupu do internej kuchyne.",
      },
      done: {
        title: "Klienti zvládnutí",
        body: "Hotovo. Pokračuj na Projekty alebo Úlohy - tutoriál sa vždy prispôsobí stránke.",
      },
    },
    dashboard: {
      intro: {
        title: "Dashboard",
        body: "Denný prehľad celej firmy na jednej obrazovke - čo horí, čo sa deje a kde stojí práca.",
      },
      hero: {
        title: "Prehľad dňa",
        body: "Rýchly sumár dňa - privítanie a to najdôležitejšie, čo ťa dnes čaká.",
      },
      stats: {
        title: "Kľúčové čísla",
        body: "Stav naprieč modulmi - projekty, úlohy, klienti a ďalšie - na jeden pohľad.",
      },
      tasks: {
        title: "Úlohy bez preklikávania",
        body: "Najnovšie úlohy priamo na dashboarde. Vedľa doplňujúce sekcie - domény a notifikácie.",
      },
      done: {
        title: "Prehľad máš",
        body: "Dashboard je štartovací bod každého dňa. Klikni do ľubovoľného modulu a spusti tam tutoriál znova.",
      },
    },
    steps: {
      welcome: {
        title: "Vitaj v MACAY",
        body: "MACAY je tvoj interný operačný systém. Tu žije všetko — projekty, úlohy, klienti, dokumenty. Prevedem ťa základmi za minútu.",
      },
      sidebar: {
        title: "Bočný panel",
        body: "Vľavo máš všetky moduly. Klikni na sekciu (Práca, Obchod, Financie…) aby si rozbalil jej podstránky. Tlmené položky s „Čoskoro” sú ešte vo vývoji.",
      },
      topbar: {
        title: "Horný panel",
        body: "Tu vidíš názov aktuálnej stránky, vyhľadávanie, prepínač témy, zvonček notifikácií a tvoj avatar. Avatar má aj odkaz do Nastavení a Odhlásenia.",
      },
      tasks: {
        title: "Úlohy",
        body: "V module Úlohy môžeš pre každý projekt vytvoriť kanban s viacerými boardmi. Úlohy môžeš presúvať drag-and-drop medzi stavmi.",
      },
      clients: {
        title: "Klienti",
        body: "Klient má vlastný login a vidí len svoje projekty. Môže komentovať úlohy, ale nezasahuje do internej kuchyne tímu.",
      },
      done: {
        title: "Pripravené",
        body: "Si pripravený. Skús si vytvoriť prvý projekt, klienta alebo úlohu. Tutoriál si môžeš kedykoľvek znova spustiť cez Nastavenia.",
      },
    },
  },

  themeToggle: {
    light: "Prepnúť na svetlú",
    dark: "Prepnúť na tmavú",
  },

  newButtons: {
    newProject: "Nový projekt",
    newClient: "Nový klient",
    newBoard: "Nový board",
    newGroup: "Nový board",
    newTask: "Nová úloha",
    cancel: "Zrušiť",
    create: "Vytvoriť",
    creating: "Vytváram…",
  },

  team: {
    title: "Tím",
    countMembers: "členov v tíme",
    memberOne: "člen v tíme",
    memberFew: "členovia v tíme",
    memberMany: "členov v tíme",
    roleAdmin: "Admin",
    superadminBadge: "Superadmin",
    makeSuperadmin: "Spraviť superadminom",
    makeSuperadminShort: "Superadmin",
    removeSuperadmin: "Odobrať superadmin",
    superadminSelfLocked: "Vlastný superadmin si nemôžeš odobrať",
    superadminGranted: "Superadmin pridelený",
    superadminRevoked: "Superadmin odobraný",
    superadminHint: "Plný prístup vrátane správy ostatných superadminov. Určiť ho môže len superadmin.",
    roleMember: "Člen",
    roleClient: "Klient",
    statusInactive: "Deaktivovaný",
    you: "ty",
    colMember: "Člen",
    colRole: "Rola",
    colClient: "Klient",
    colTasks: "Otvorené úlohy",
    colJoined: "V tíme od",
    statAdmins: "Admini",
    statMembers: "Členovia",
    statClients: "Klienti",
    statInvites: "Čakajúce pozvánky",
    inviteButton: "Pozvať člena",
    inviteTitle: "Pozvať nového člena",
    inviteName: "Meno a priezvisko",
    inviteNamePlaceholder: "Jana Nováková",
    inviteEmail: "Email",
    inviteEmailPlaceholder: "jana@firma.sk",
    inviteRole: "Rola",
    inviteClient: "Klient",
    inviteClientPick: "Vyber klienta…",
    inviteCreate: "Vytvoriť pozvánku",
    inviteCreating: "Vytváram…",
    inviteReadyTitle: "Pozvánka je pripravená",
    inviteReadyHint: "Pošli tento odkaz novému členovi - po otvorení si nastaví heslo a účet je aktívny. Odkaz platí 7 dní.",
    copyLink: "Kopírovať odkaz",
    copied: "Skopírované",
    done: "Hotovo",
    pendingTitle: "Čakajúce pozvánky",
    pendingExpires: "platí do",
    pendingExpired: "expirovaná",
    revoke: "Zrušiť",
    editTitle: "Upraviť člena",
    sectionsLabel: "Viditeľné sekcie",
    sectionsHint: "Nezaškrtnuté sekcie používateľ v aplikácii neuvidí. Dashboard, notifikácie a nastavenia sú dostupné vždy.",
    projectsLabel: "Prístup k projektom",
    projectsHint: "Member vidí len projekty, do ktorých je priradený, vrátane ich klientov a úloh. Priradiť ho vieš aj neskôr v detaile projektu.",
    noProjects: "Zatiaľ žiadne projekty",
    editClientHint: "Klientsky účet vidí len projekty priradeného klienta.",
    deactivate: "Deaktivovať účet",
    activate: "Aktivovať účet",
    save: "Uložiť",
    saving: "Ukladám…",
    deactivatedNote: "Deaktivovaný účet sa nemôže prihlásiť, jeho história ostáva.",
    archive: "Archivovať účet",
    archiveConfirm: "Naozaj archivovať?",
    archivedNote: "Archivovaný účet zmizne zo zoznamov a výberov, história úloh ostáva.",
    archivedSectionTitle: "Archivované účty",
    archivedSectionHint: "Obnov účet späť do tímu (vráti sa ako deaktivovaný) alebo ho zmaž natrvalo.",
    restoreAccount: "Obnoviť účet",
    archivedAtLabel: "Archivovaný",
    deleteForever: "Zmazať natrvalo",
    deleteForeverConfirm: "Naozaj natrvalo?",
    deleteForeverNote: "Natrvalo zmazaný účet sa nedá obnoviť - zmizne z tímov aj priradení a v histórii úloh ostane ako Neznámy.",
    deletedToast: "Účet natrvalo zmazaný",
    accountSection: "Správa účtu",
    nameRequired: "Vyplň meno",
    emailRequired: "Vyplň platný email",
    clientRequired: "Vyber klienta",
    modeLink: "Pozvánka linkom",
    modeDirect: "Priamo s heslom",
    directPassword: "Heslo",
    directPasswordPlaceholder: "Minimálne 8 znakov",
    generate: "Generovať",
    directCreate: "Vytvoriť účet",
    directCreating: "Vytváram…",
    directReadyTitle: "Účet je vytvorený",
    directReadyHint: "Pošli prihlasovacie údaje novému členovi - prihlási sa s nimi na login stránke. Heslo si potom môže zmeniť v nastaveniach.",
    copyCreds: "Kopírovať údaje",
    passwordShort: "Heslo musí mať aspoň 8 znakov",
    invitePage: {
      title: "Vitaj v MACAY",
      subtitle: "Nastav si heslo a tvoj účet je pripravený.",
      joiningAs: "Pripájaš sa ako",
      password: "Heslo",
      passwordPlaceholder: "Minimálne 8 znakov",
      password2: "Heslo znova",
      passwordMismatch: "Heslá sa nezhodujú",
      passwordShort: "Heslo musí mať aspoň 8 znakov",
      submit: "Vytvoriť účet a prihlásiť",
      submitting: "Vytváram účet…",
      invalidTitle: "Pozvánka nie je platná",
      invalidSub: "Odkaz je neplatný, expirovaný alebo už bol použitý. Požiadaj admina o novú pozvánku.",
      toLogin: "Na prihlásenie",
    },
  },
  clientProfile: {
    overviewHeading: "Prehľad",
    billingHeading: "Fakturačné údaje",
    contactsHeading: "Kontaktné osoby",
    notesHeading: "Poznámky",
    edit: "Upraviť",
    save: "Uložiť",
    saving: "Ukladám…",
    cancel: "Zrušiť",
    web: "Web",
    segment: "Segment",
    owner: "Account manager",
    ownerNone: "Nepriradený",
    ownerPick: "Vyber člena tímu…",
    segmentPlaceholder: "napr. Gastro, E-shop, B2B…",
    webPlaceholder: "https://…",
    overviewEmpty: "Web, segment a account manager zatiaľ nevyplnené.",
    editOverview: "Upraviť prehľad",
    billingName: "Fakturačné meno",
    billingNamePlaceholder: "Ak iné než názov klienta",
    ico: "IČO",
    dic: "DIČ",
    icDph: "IČ DPH",
    address: "Adresa",
    street: "Ulica a číslo",
    city: "Mesto",
    zip: "PSČ",
    country: "Krajina",
    iban: "IBAN",
    bank: "Banka",
    paymentTerm: "Splatnosť",
    paymentTermDays: "dní",
    paymentTermPlaceholder: "napr. 14",
    currency: "Mena",
    billingEmpty: "Fakturačné údaje zatiaľ nevyplnené.",
    editBilling: "Upraviť fakturačné údaje",
    addContact: "Pridať kontakt",
    editContact: "Upraviť kontakt",
    newContact: "Nový kontakt",
    contactName: "Meno",
    contactNamePlaceholder: "Meno a priezvisko",
    contactPosition: "Pozícia",
    contactPositionPlaceholder: "napr. Konateľ, Marketing…",
    contactEmail: "Email",
    contactPhone: "Telefón",
    primary: "Hlavný",
    makePrimary: "Nastaviť ako hlavný",
    removeContact: "Odstrániť kontakt",
    contactNameRequired: "Meno kontaktu je povinné",
    contactsEmpty: "Žiadne kontaktné osoby.",
    removeContactConfirm: "Odstrániť tento kontakt?",
    notePlaceholder: "Napíš poznámku… (Cmd/Ctrl+Enter odošle)",
    addNote: "Pridať poznámku",
    notesEmpty: "Žiadne poznámky.",
    removeNote: "Odstrániť poznámku",
    noteBy: "od",
    savedToast: "Uložené",
  },

  errors: {
    notSignedIn: "Nie si prihlásený",
    noPermission: "Bez oprávnenia",
    badId: "Neplatné ID",
    generic: "Niečo sa pokazilo",
    tryAgain: "Skús to znova",
    reload: "Znova načítať",
    goHome: "Späť na dashboard",
    goBack: "Späť",
    pageNotFound: "Tento modul sme ešte",
    pageNotFoundEmphasis: "nepostavili",
    notFoundTermScan: "skenujem moduly…",
    notFoundTermErr: "modul sa nenašiel",
    notFoundTermHint: "napíš „help“ a stlač Enter",
    notFoundTermUnknown: "príkaz nenájdený",
    notFoundTermHelp: "dostupné: home · back · clear · help",
    appUpdatedTitle: "Aplikácia bola aktualizovaná",
    appUpdatedSub: "Načítavam najnovšiu verziu… stránka sa o chvíľu obnoví sama.",
    retryHint: "Skús akciu zopakovať. Ak problém pretrváva, obnov stránku.",
    pageNotFoundSub:
      "Stránka, ktorú hľadáte, sa niekde stratila medzi projektmi, faktúrami a dvanástimi appkami.",
    pageNotFoundGood: "Dobrá správa: presne to riešime.",
  },
  toasts: {
    boardCreated: "Board vytvorený",
    boardDeleted: "Board zmazaný",
    groupCreated: "Board vytvorený",
    projectCreated: "Projekt vytvorený",
    projectDeleted: "Projekt zmazaný",
    statusChanged: "Status zmenený",
    fileUploaded: "Súbor nahraný",
    removed: "Odstránené",
    clientCreated: "Klient vytvorený",
    contactAdded: "Kontakt pridaný",
    inviteSent: "Pozvánka odoslaná",
    inviteResent: "Pozvánka znova odoslaná",
    inviteCancelled: "Pozvánka zrušená",
    memberAdded: "Člen pridaný",
    userRestored: "Používateľ obnovený",
    userDeleted: "Používateľ zmazaný",
    restored: "Obnovené",
    permanentlyDeleted: "Natrvalo zmazané",
    reportCreated: "Report vytvorený",
    contributionSaved: "Tvoja časť uložená",
    markedFinal: "Časť označená ako finálna",
    markedPending: "Označenie zrušené",
    reportApproved: "Report schválený",
    reportSent: "Report odoslaný klientovi",
    reportDeleted: "Report zmazaný",
  },

  reports: {
    title: "Reporty",
    subtitle: "Reporty pre klientov — čo sa urobilo a bude fakturované.",
    newReport: "Nový report",
    internal: "Interné",
    internalReport: "Interný report",
    modeClient: "Pre klienta",
    modeInternal: "Interný",
    reportTitle: "Názov reportu",
    titlePlaceholder: "Napr. Máj 2026, Kampaň jar…",
    titleRequired: "Názov reportu je povinný",
    pickClient: "Vyber klienta",
    pickClientHint: "Report sa vytvorí pre aktuálny týždeň z úloh s aktivitou.",
    detailsHeading: "Detaily reportu",
    periodOptional: "Obdobie (voliteľné)",
    periodFrom: "Od",
    periodTo: "Do",
    peopleHeading: "Ľudia",
    peopleOptional: "Riešitelia (voliteľné)",
    peopleHint: "Pridaní ľudia doplnia svoju časť a sú upozorňovaní na zmeny.",
    createdByLabel: "Vytvoril",
    addPerson: "Pridať človeka",
    pickPerson: "Vyber člena tímu…",
    removePerson: "Odobrať",
    thisWeek: "Tento týždeň",
    weekPrefix: "Týždeň",
    createForClient: "Vytvoriť report",
    creating: "Vytváram…",
    emptyTitle: "Zatiaľ žiadne reporty",
    emptySub: "Vytvor prvý týždenný report pre klienta.",
    noActivity: "Žiadna aktivita v tomto týždni — niet z čoho zostaviť report.",
    alreadyExists: "Report pre tohto klienta a týždeň už existuje.",
    contributorsProgress: "hotových",
    openReport: "Otvoriť report",
    searchPlaceholder: "Hľadať report…",
    onlyMine: "Len moje",
    sortRecent: "Naposledy upravené",
    sortPeriod: "Podľa obdobia",
    sortStatus: "Podľa stavu",
    sortManual: "Manuálne poradie",
    noMatch: "Nič sa nenašlo",
    backToList: "Späť na reporty",
    print: "PDF",
    share: "Zdieľať",
    preparingPdf: "Vytváram PDF…",
    linkCopied: "Odkaz skopírovaný",

    statusCollecting: "Zbieranie podkladov",
    statusReview: "Na kontrolu",
    statusApproved: "Schválený",
    statusSent: "Odoslaný",

    summaryHeading: "Zhrnutie pre klienta",
    summaryHint: "Ľudskou rečou zhrň, čo sa pre klienta urobilo a bude fakturované.",
    summaryPlaceholder: "Tento týždeň sme pre vás…",
    summaryEmpty: "Zhrnutie zatiaľ nie je vyplnené.",
    saveSummary: "Uložiť zhrnutie",

    contributionsHeading: "Časti riešiteľov",
    contributionsHint: "Priradení ľudia píšu priamo do reportu a svoju účasť potvrdia ako hotovú.",
    yourPart: "Tvoja časť",
    yourPartPlaceholder: "Čo si tento týždeň pre klienta spravil(a)…",
    saveDraft: "Uložiť",
    saving: "Ukladám…",
    saved: "Uložené",
    markFinal: "Označiť ako finálne",
    markPending: "Vrátiť na rozpracované",
    finalBadge: "Finálne",
    pendingBadge: "Rozpracované",
    emptyContribution: "Zatiaľ nevyplnené",
    contributorsEmpty: "Žiadni priradení riešitelia pre tento týždeň.",

    attachmentsHeading: "Podklady a screenshoty",
    addAttachment: "Pridať prílohu",
    attachmentsEmpty: "Žiadne prílohy.",
    removeAttachment: "Odstrániť prílohu",
    downloadAll: "Stiahnuť všetko (.zip)",

    linksHeading: "Odkazy",
    addLink: "Pridať odkaz",
    linkUrlPlaceholder: "https://…",
    linkDescPlaceholder: "Popis (voliteľné)",
    linksEmpty: "Žiadne odkazy.",
    removeLink: "Odstrániť odkaz",
    openAll: "Otvoriť všetky",
    moveUp: "Posunúť vyššie",
    moveDown: "Posunúť nižšie",
    rename: "Premenovať",
    renamePrompt: "Nový názov reportu",
    duplicate: "Duplikovať",
    reportDuplicated: "Report duplikovaný",

    publicLinkHeading: "Odkaz pre klienta",
    publicLinkHint: "Zdieľaj klientovi tento view-only odkaz (bez účtu).",
    copyLink: "Kopírovať odkaz",
    copied: "Skopírované",

    approve: "Schváliť",
    approving: "Schvaľujem…",
    unapprove: "Vrátiť na kontrolu",
    send: "Odoslať klientovi",
    sending: "Odosielam…",
    sendConfirm: "Odoslať report klientovi? Dostane e-mail s odkazom.",
    resend: "Odoslať znova",
    deleteReport: "Zmazať report",
    deleteConfirm: "Naozaj zmazať tento report?",

    gateNotAllFinal: "Všetci riešitelia musia označiť svoju časť ako finálnu.",
    gateNeedsSummary: "Pred odoslaním vyplň zhrnutie pre klienta.",
    gateReviewFirst: "Report treba najprv schváliť.",
    approvedNote: "Schválené — pripravené na odoslanie.",
    internalFinalizedNote: "Interný report — schválené (neodosiela sa klientovi).",
    sentNote: "Odoslané klientovi",
    approvedBy: "Schválil",
    contributorsCount: "riešiteľov",

    publicHeading: "Týždenný report",
    publicPeriod: "Obdobie",
    publicInvalidTitle: "Report nie je dostupný",
    publicInvalidSub: "Odkaz je neplatný alebo report ešte nebol odoslaný.",
    poweredBy: "Vytvorené v MACAY",
    sentOn: "Odoslané",

    editor: {
      bold: "Tučné",
      italic: "Kurzíva",
      underline: "Podčiarknuté",
      heading: "Nadpis",
      subheading: "Podnadpis",
      bulletList: "Odrážky",
      numberList: "Číslovaný zoznam",
      link: "Odkaz",
      image: "Obrázok",
      linkPrompt: "Zadaj URL odkazu",
      textColor: "Farba textu",
      fontSize: "Veľkosť písma",
      alignLeft: "Vľavo",
      alignCenter: "Na stred",
      alignRight: "Vpravo",
      sizeSmall: "Malé",
      sizeNormal: "Normálne",
      sizeLarge: "Veľké",
      sizeHuge: "Obrovské",
    },
  },
};

export type Messages = typeof sk;
